import { alpha } from "@mui/material";
import { lighten } from "@mui/system";

// Estilos compartilhados por serviceItem.js e index.js (nível 2.3-circuito) —
// os estilos exclusivos do preview (boxCampos/icons/typhographyTitle/
// typographyLabel/divider/boxContent/observationsTypography/boxChip) foram
// distribuídos para os styles.js de previewData/ e seus subcomponentes na
// Task 7 da decomposição.
const styles = (theme) => ({
	paper: {
		display: "flex",
		flexDirection: "column",

		gap: 2,
		position: "relative",
	},
	boxSwitch: {
		display: "flex",
		width: "100%",
		justifyContent: "flex-end",
		alignItems: "center",
	},
	switch: {
		width: 42,
		height: 26,
		padding: 0,
		"& .MuiSwitch-switchBase": {
			padding: 0,
			margin: 0.2,
			transitionDuration: "300ms",
			"&.Mui-checked": {
				transform: "translateX(16px)",
				color: "#fff",
				"& + .MuiSwitch-track": {
					backgroundColor: theme.palette.primary.main,
					opacity: 1,
					border: 0,
				},
				"&.Mui-disabled + .MuiSwitch-track": {
					opacity: 0.5,
				},
			},
			"&.Mui-focusVisible .MuiSwitch-thumb": {
				color: theme.palette.primary.main,
				border: "6px solid #fff",
			},
			"&.Mui-disabled .MuiSwitch-thumb": {
				color:
					theme.palette.mode === "dark"
						? theme.palette.grey[600]
						: theme.palette.grey[100],
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: theme.palette.mode === "dark" ? 0.3 : 0.7,
			},
		},
		"& .MuiSwitch-thumb": {
			boxSizing: "border-box",
			width: 22,
			height: 22,
		},
		"& .MuiSwitch-track": {
			borderRadius: 26 / 2,
			backgroundColor:
				theme.palette.mode === "dark"
					? lighten(theme.palette.colors.black.dark, 0.4)
					: theme.palette.colors.gray.medium,
			opacity: 1,
			transition: theme.transitions.create(["background-color"], {
				duration: 500,
			}),
		},
	},
	linearProgress: {
		top: 1,
		left: 1,
		zIndex: 1,
		width: "99.9%",
		position: "absolute",
	},
	accordion: {
		transition: "all 0.2s ease", // suaviza animações
		"&:hover": {
			// efeito de elevação
			transform: "translateY(-2px)",
			boxShadow: `0px 4px 12px ${theme.palette.colors.black.darker}4D`,
		},
	},
	accordionTextStatus: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: 1,
	},
	summaryTextOverflow: {
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 2,
		overflow: "hidden",
		textOverflow: "ellipsis",
		// Fallback para navegadores que não suportam -webkit-line-clamp
		maxHeight: "3em", // Aproximadamente 2 linhas (1.5em por linha)
		lineHeight: 1.5,
	},
	accordionSummary: {
		"& .MuiAccordionSummary-content": {
			minWidth: 0, // Crucial para ellipsis
			overflow: "hidden",
		},
	},
	containerServiceItem: {
		display: "flex",
		flexDirection: "column",
		position: "relative",
	},
	containerTabsNActionButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		mt: 1,
	},
	tabs: {
		minHeight: 32,
		"& .MuiTabs-indicator": {
			display: "none", // remove a linha padrão
		},
	},
	tab: {
		minHeight: 32,
		paddingY: 0.5,
		px: 1,
		mx: 0.05,
		fontSize: "0.875rem",
		textTransform: "none",
		borderTopLeftRadius: "8px",
		borderTopRightRadius: "8px",
		border: "1px solid transparent",
		borderBottom: "none",
		transition: "all 0.2s ease",
	},

	tabLabel: {
		display: "flex",
		alignItems: "center",
		gap: 0.25,
	},
	tabCloseButton: {
		ml: 0.5,
		p: 0.1,
	},
	tabCloseIcon: {
		height: 16,
	},
	addTabDivider: {
		alignSelf: "center",
		height: "24px",
		borderRightWidth: 2,
		ml: 0.2,
	},
	addTabButton: {
		p: 0.5,
	},
	boxButtons: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: 1,
		flexDirection: "row",
	},
	//cards do circuito
	paperFluxo: {
		borderRadius: "16px",
		flex: 1,
		height: "100%",
		overflowY: "auto",
		position: "relative",
		p: 1,
	},
	boxBlur: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "78px",
		zIndex: 2,
		backgroundColor: alpha(theme.palette.background.paper, 0.8),
		backdropFilter: "blur(6px)",
		transform: "translateY(7px)",
		borderTopLeftRadius: "30px",
		clipPath: "inset(0px 16px 0 10px)",
	},
	boxBody: {
		width: "100%",
		display: "flex",
		gap: 1,
		height: "700px",
		p: 1,
	},
	headStcker: {
		display: "flex",
		flexDirection: "column",
		position: "sticky",
		backgroundColor: "transparent",
		top: 0,
		zIndex: 99,
		pt: 1,
		mb: -2,
	},
	// Ações do cabeçalho do painel (adicionar circuito + Editar/Salvar/Cancelar)
	headerActions: {
		display: "flex",
		gap: 1,
		flexDirection: "row",
		alignItems: "center",
	},
	// Botão "Expandir/Recolher Todos" no cabeçalho da lista de serviços (adaptação visual do padrão 9.0-clientesSwap)
	boxExpandAll: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		gap: 1,
		mb: 1,
	},
	// Linha do cabeçalho do card de serviço (botão de expandir + conteúdo principal), lado a lado
	cardHeaderRow: {
		display: "flex",
		alignItems: "stretch",
		position: "relative",
	},
	// Botão de expandir/recolher os subitens de circuito do serviço
	circuitExpandMedia: {
		width: "auto",
		minWidth: "40px",
		display: "flex",
		borderLeft: "none",
		position: "relative",
	},
	circuitExpandAction: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		width: "100%",
		transition: "background-color 0.2s",
	},
	// Conteúdo principal do card (dados do serviço), ao lado do botão de expandir — padding
	// reduzido (padrão visual do 9.0-clientesSwap); paddingX aplicado inline por hasChildren
	cardMainAction: {
		paddingY: 1.5,
		flexGrow: 1,
		minWidth: 0,
	},
	// Menu de ações do serviço (more vert), sempre acessível independente de modo edição
	serviceMenuMedia: {
		width: "auto",
		minWidth: "40px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		position: "relative",
	},
	serviceMenuButton: {
		m: "auto",
	},
	// Lista de subitens de circuito dentro do CardSelection (Task 6), agora dentro de um Collapse —
	// cada subitem é seu próprio "mini card" (padrão visual do 9.0-clientesSwap), com a linha
	// conectora pai/filho mantida (pedido explícito) apontando pro card em vez de uma linha solta
	circuitList: {
		display: "flex",
		flexDirection: "column",
		// Sem gap: o espaçamento entre cards vem do padding-bottom de cada circuitConnectorWrap
		// (ver comentário abaixo) — um flex `gap` deixaria um vão em branco onde a linha vertical
		// não é desenhada (ela só existe dentro do próprio wrap), quebrando a espinha da árvore
		gap: 0,
		mt: 0.5,
		ml: 2.5,
		pr: 0.75,
		pb: 0.5,
	},
	// Linha conectora (vertical/horizontal) entre o serviço pai e cada subitem de circuito — a espora
	// horizontal termina exatamente na borda esquerda do card (circuitConnectorWrap.pl bate com a
	// largura da espora), então ela "flui" visualmente até a barra colorida do card, sem sobrepor.
	// pb (aplicado por item, exceto o último — ver cardSelection.js) é padding, não margin nem gap
	// do container: a linha vertical (top:0/bottom:0) atravessa esse padding sem interrupção, então
	// o espaçamento entre cards não deixa buraco na espinha da árvore.
	circuitConnectorWrap: {
		position: "relative",
		pl: 3,
	},
	circuitConnectorVertical: {
		position: "absolute",
		left: 0,
		borderLeft: `3px solid ${theme.palette.colors.green.light}`,
	},
	circuitConnectorHorizontal: {
		position: "absolute",
		left: 0,
		top: "50%",
		width: "24px",
		borderTop: `3px solid ${theme.palette.colors.green.light}`,
	},
	// Subitem de circuito: barra de cor cheia à esquerda (via ::before), mesmo tratamento
	// visual do card de trecho/subtrecho do 9.0-clientesSwap
	circuitItem: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 1,
		pl: 1.5,
		pr: 1,
		py: 0.75,
		position: "relative",
		overflow: "hidden",
		// Menos arredondado que o padrão (2): num card baixo/compacto como este, um raio maior
		// lê como "redondo demais" proporcionalmente à altura
		borderRadius: 1,
		border: `1px solid ${theme.palette.divider}`,
		cursor: "pointer",
		transition: "background-color 0.15s ease",
		"&::before": {
			content: '""',
			position: "absolute",
			left: 0,
			top: 0,
			width: "5px",
			height: "100%",
			bgcolor: theme.palette.colors.green.light,
		},
		"&:hover": {
			backgroundColor: "action.hover",
		},
	},
	circuitItemSelected: {
		backgroundColor: "action.selected",
		"&:hover": {
			backgroundColor: "action.selectedHover",
		},
	},
	circuitItemLabel: {
		display: "flex",
		alignItems: "center",
		gap: 0.5,
		minWidth: 0,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		pl: 0.5,
	},
	// Ícones de conteúdo do circuito (formulário/anexos/diagrama), mesma lógica do 9.0-clientesSwap:
	// coloridos quando o circuito possui aquele dado, text.disabled quando não (tooltip explica)
	circuitItemIcons: {
		display: "flex",
		alignItems: "center",
		gap: 0.75,
		flexShrink: 0,
	},
	circuitItemClose: {
		p: 0.2,
	},
});

export default styles;
